var _rect, _text, _text2, _text3, _rect2, _g, _line, _path, _text4, _rect3, _g2, _rect4, _text5, _text6, _line2, _path2, _text7, _rect5, _text8, _g3, _text9, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForesightFig3SynthesisPipeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Thirty documents in, one method out")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Expert literature compressed into mode-scoped reference files that feed a single pipeline")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "29 SOURCE DOCUMENTS, ~120 MB")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 142,
    width: 330,
    height: 330,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 13,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 180,
    fontWeight: 600
  }, "Institute for the Future"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 198,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Gorbis, McGonigal, Cascio"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 234,
    fontWeight: 600
  }, "Stanford d.school"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 252,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Playbook for Strategic Foresight"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 288,
    fontWeight: 600
  }, "Pherson, Donner, Gnad"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 306,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Clear Thinking, Springer 2024"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 342,
    fontWeight: 600
  }, "Jane McGonigal"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 360,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Imaginable, 2022"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 396,
    fontWeight: 600
  }, "Seven academic papers"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 414,
    fontSize: 12,
    fill: "#4A5F56"
  }, "scenario methodology, futures"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 430,
    fontSize: 12,
    fill: "#4A5F56"
  }, "metacognition, collective sensemaking"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 378,
    y1: 307,
    x2: 420,
    y2: 307,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420 301 l10 6 l-10 6 z",
    fill: "#D4DDD6"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "11 REFERENCE FILES, ~1,500 LINES")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 142,
    width: 300,
    height: 330,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12.5,
    fill: "#4A5F56",
    fontFamily: "'Geist Mono', Consolas, monospace"
  }, /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 178
  }, "frameworks.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 202
  }, "signals.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 226
  }, "scenarios.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 250
  }, "evaluation.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 274
  }, "techniques.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 298
  }, "content.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 322
  }, "terminology.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 346
  }, "cognitive.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 370
  }, "guide.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 394
  }, "signal-store.md"), /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 418
  }, "signal-analysis.md"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 484,
    width: 300,
    height: 52,
    rx: 8,
    fill: "#EAF6EE",
    stroke: "#16A34A",
    strokeWidth: 1.2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 592,
    y: 506,
    fontSize: 12,
    fill: "#14532D",
    textAnchor: "middle"
  }, "Each mode loads only its 2 or 3 files.")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 592,
    y: 522,
    fontSize: 12,
    fill: "#14532D",
    textAnchor: "middle"
  }, "The Reference Index is the whole design.")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 742,
    y1: 307,
    x2: 784,
    y2: 307,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M784 301 l10 6 l-10 6 z",
    fill: "#D4DDD6"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 130,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#7C3AED",
    fontWeight: 600
  }, "ONE PIPELINE, WRAPPED IN THE IFTF CYCLE")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 142,
    width: 346,
    height: 394,
    rx: 16,
    fill: "none",
    stroke: "#7C3AED",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 170,
    fontSize: 12.5,
    fill: "#4A2A85",
    textAnchor: "middle",
    fontWeight: 600
  }, "Foresight &#8594; Insight &#8594; Action")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 190,
    width: 210,
    height: 46,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 219,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Signals"), /*#__PURE__*/React.createElement("line", {
    x1: 979,
    y1: 236,
    x2: 979,
    y2: 252,
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 252 l6 10 l6 -10 z",
    fill: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 262,
    width: 210,
    height: 46,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 291,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Drivers"), /*#__PURE__*/React.createElement("line", {
    x1: 979,
    y1: 308,
    x2: 979,
    y2: 324,
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 324 l6 10 l6 -10 z",
    fill: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 334,
    width: 210,
    height: 46,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 363,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Forecasts"), /*#__PURE__*/React.createElement("line", {
    x1: 979,
    y1: 380,
    x2: 979,
    y2: 396,
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 396 l6 10 l6 -10 z",
    fill: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 406,
    width: 210,
    height: 46,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 435,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Scenarios"), /*#__PURE__*/React.createElement("line", {
    x1: 979,
    y1: 452,
    x2: 979,
    y2: 468,
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973 468 l6 10 l6 -10 z",
    fill: "#D4DDD6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 478,
    width: 210,
    height: 46,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 979,
    y: 507,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, "Artifacts"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 560,
    fontSize: 12.5,
    fill: "#6B7F74"
  }, "Every output except Brief mode is self-scored against the Cascio Pentagon (logical, complex,")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 578,
    fontSize: 12.5,
    fill: "#6B7F74"
  }, "evocative, provocative, stimulating) and the Five Principles for Engaging Foresight.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForesightFig3SynthesisPipeline);
export default __webpack_public_path__ + "static/media/foresight-fig3-synthesis-pipeline.d9c1ec09f1c5929b8357f21862b5acd6.svg";
export { ForwardRef as ReactComponent };